import { Box, Inline, Text } from 'braid-design-system';
import React, { type ComponentType, type ReactNode } from 'react';

interface Props {
  icon?: ComponentType;
  text: ReactNode;
}

const CommonNudge = ({ icon: Icon, text }: Props) => (
  <Box background="infoLight" paddingX="gutter" paddingY="medium">
    <Inline space="medium" alignY="center">
      {Icon ? <Icon /> : null}
      <Text>{text}</Text>
    </Inline>
  </Box>
);

export default CommonNudge;
